




























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Models
import { BankAccount } from '@/shared/models/bankAccount.model';
import { BudgetSepaInfo } from '@/client/budget/models/budget-sepa-info.model';

// Components
import FieldSet from '@/shared/components/field-set.component.vue';
import Field from '@/shared/components/field.component.vue';
import Input, {
    InputType,
    InputStyle,
} from '@/shared/components/input.component.vue';
import FlatSelectorText, {
    FlatSelectorTextBorderBottom,
    FlatSelectorTextPredefinedStyle,
    FlatSelectorTextWeight,
    FlatSelectorTextSize,
} from '@/shared/components/FlatSelectorText.component.vue';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';



@Component({
    components: {
        Field,
        FieldSet,
        Input,
        FlatSelectorText,
    },
    computed: {
        ...mapGetters({
            currentBudget: 'getCurrentBudgetAcceptance',
            bankList: 'getBankList',
            acceptanceFieldError: 'getAcceptanceFieldError',
        }),
    },
    methods: {
        ...mapActions({
            setCurrentBudgetAcceptance: 'setCurrentBudgetAcceptance',
            fetchBankList: 'fetchBankList',
        }),
    },
})
export default class PaymentMethodDirectDebit extends Mixins<ErrorMixin> (ErrorMixin) {
    @Prop({ default: false }) private readOnly!: boolean;


    private inputType = InputType;
    private currentBudget!: any;
    private setCurrentBudgetAcceptance!: any;
    private fetchBankList!: any;
    private acceptanceFieldError!: any;
    private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
    private flatSelectorTextWeight = FlatSelectorTextWeight;
    private flatSelectorTextSize = FlatSelectorTextSize;
    private budgetSepaInfo = new BudgetSepaInfo();


    @Watch('budgetSepaInfo', { deep: true })
    private watchBudgetSepaInfo(newVal: BudgetSepaInfo, oldVal: BudgetSepaInfo) {
        this.currentBudget.budgetSepaInfo = newVal;
        this.updateCurrentBudgetAcceptance();
    }

    @Watch('acceptanceFieldError')
    private watchAcceptanceFieldError(newVal: any, oldVal: any) {
        this.error = Object.assign({}, newVal);
    }


    private created() {
        if ( !this.currentBudget.bankAccount ) {
            this.currentBudget.bankAccount = new BankAccount();
        }
        if ( this.currentBudget.budgetSepaInfo ) {
            this.budgetSepaInfo = this.currentBudget.budgetSepaInfo;
        }
        if ( !this.readOnly ) {
            this.fillAddressData();
        }
        this.firstSearch();
    }


    private bankSearch(searchObject: any) {
        this.fetchBankList({
            search: searchObject.searchString,
            limit: searchObject.limit,
        });
    }

    private firstSearch() {
        const search = {
            search: '',
            limit: 5,
        };
        this.bankSearch(search);
    }

    private updateCurrentBudgetAcceptance() {
        this.setCurrentBudgetAcceptance(this.currentBudget);
    }

    private fillAddressData() {
        if ( this.currentBudget.client.user.profile ) {
            this.budgetSepaInfo = {
                address: this.currentBudget.client.user.profile.address,
                postalCode: this.currentBudget.client.user.profile.postalCode,
                town: this.currentBudget.client.user.profile.town,
                state: this.currentBudget.client.user.profile.state,
            };
        }
    }

}
